import { Component, OnInit, TemplateRef } from '@angular/core';
import * as numeral from 'numeral';
import { Retencion } from '../../../models/retencion';
import { RetencionService } from '../../../services/retencion.service';
import { RetencionModalComponent } from '../../../components/modals/retencion-modal/retencion-modal.component';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { SessionService } from '../../../services/session.service';
import { ParametroService } from '../../../services/parametro.service';
import { ConfirmacionAnulacionModalComponent } from '../../modals/confirmacion-anulacion-modal/confirmacion-anulacion-modal.component';
import { SweetMessage } from '../../../config/sweet-message';
import { VentaModalComponent } from '../../modals/venta-modal/venta-modal.component';

import * as moment from 'moment';
import { AsientoContableDetalleModalComponent } from '../../modals/asiento-contable-modal/asiento-contable-detalle-modal.component';

@Component({
	selector: 'retenciones-list',
	templateUrl: './retenciones-list.component.html',
	styleUrls: ['./retenciones-list.component.css'],
	providers: [RetencionService, ParametroService]
})
export class RetencionesListComponent implements OnInit {
	public retenciones: any;
	public bsModalRef: BsModalRef;
	public bsModalRefAnulacion: BsModalRef;
	public bsModalRefPregunta: BsModalRef;
	public loading = false;
	public numero_decimales: number;
	public retencion_anulada: Retencion;
	public format_decimal: String;
	public observacion: String;
	public msg: SweetMessage;
	public total:any;


	constructor(
		public retencionService: RetencionService,
		private modalService: BsModalService,
		private ss: SessionService,
		public parametroService: ParametroService,
	) {
		this.retenciones = [];
		this.retenciones.detalle = [];
		this.numero_decimales = 2;
		this.format_decimal = "0,0.00";
		this.retencion_anulada = new Retencion();
		this.observacion = "";
		this.total = 0;
	
		this.msg = new SweetMessage();
	}

	ngOnInit() {
		this.loading = true;
		let p1 = this.getParamNumeroDecimales();
		let p2 = this.getRetenciones();

		Promise.all([p1,p2]).then(
			res => this.loading = false,
			err => this.loading = false
		);
	}

	getRetenciones(){
		this.loading = true;
		return new Promise((resolve, reject) => {
			//"?status=A,tipo=V&embed=venta?embed=cliente&sort=-fecha_emision,-secuencial&usuario_id="+this.ss.getData('usuario_id')
			let now = moment();							
			this.retencionService.getAll("?status=A&tipo=V&fecha_emision=" + moment(now.format("YYYY-MM-DD"), moment.ISO_8601).format() + "&embed=detalle,asientocontable,venta?embed=cliente&sort=-fecha_emision,-secuencial&usuario_id="+this.ss.getData('usuario_id')).subscribe(
				res => {
					this.retenciones = res.data;
					this.retenciones.detalle = [];
					this.retenciones.forEach(retencion => {
						retencion.total_renta = 0;
						retencion.total_iva = 0;
						this.total += parseFloat(retencion.total.toString());
						retencion.detalle.forEach( item => {
							if(item.impuesto_id == '1'){
								retencion.total_renta += Number(item.total);
							}
							if(item.impuesto_id == '2'){
								retencion.total_iva += Number(item.total);
							}
						});
						
					});
					this.loading = false;
					resolve();
				},
				err => {
					this.retenciones = [];
					this.loading = false;
					reject(err);
				}
			);
		});
	}

	getNumeroDocumento(retencion){
		return retencion.serie + "-" + retencion.punto_emision + "-" + retencion.secuencial;
	}

	onShow(id){
		const initialState = {retencion_id: id, numero_decimales: this.numero_decimales};
		this.bsModalRef = this.modalService.show(RetencionModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));
	}
	onShowAsiento(asiento){
		const initialState = {asiento_id: asiento.id, tipo_transaccion_contabilidad_id: asiento.tipo_transaccion_contabilidad_id};
		this.bsModalRef = this.modalService.show(AsientoContableDetalleModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));
  	}

	getParamNumeroDecimales(){
        return new Promise((resolve, reject) => {
            let numero_decimales = 19;
            this.parametroService.getById(numero_decimales).subscribe(
                res => {
                    this.numero_decimales = res.valor;

                    let digitos = "";
                    for(let i = 0; i < this.numero_decimales; i++) digitos += "0";
                    this.format_decimal = "0,0." + digitos
                    resolve();
                },
                err => {
                    this.numero_decimales = 2;
                    this.format_decimal = "0,0.00"
                    reject(err);
                }
            );
        });
    }

    get formatDecimal(){
        return this.format_decimal;
	}
	
	anular(template: TemplateRef<any>, retencion: Retencion){
		this.observacion = retencion.observacion;
		this.retencion_anulada = retencion;
		this.bsModalRefAnulacion = this.modalService.show(template);
		//this.bsModalRef2 = this.bsModalRef;
	}

	anularRetencion(){
		this.bsModalRefAnulacion.hide();
		let preg = "¿Está seguro de querer anular el documento?";
		const initialState = { Pregunta: preg, Respuesta:false };
		this.bsModalRefPregunta = this.modalService.show(ConfirmacionAnulacionModalComponent, Object.assign({}, {initialState}));

		this.bsModalRefPregunta.content.action.take(1).subscribe((Respuesta) => {
			if(Respuesta == true){
				this.retencion_anulada.observacion = this.observacion.toString().trim();
				this.retencion_anulada.usuario_id = this.ss.getData("usuario_id");
				this.observacion  = "";
				
				this.loading = true;

				this.retencionService.anular(this.retencion_anulada).subscribe(
					res => {
						this.bsModalRefPregunta.hide();
						this.retencion_anulada = new Retencion();

						this.msg.showMessage('success-message', 'Se ha procesado correctamente');

						this.getRetenciones().then(
							res => {
								this.loading = false;
							},
							err => {
								this.loading = false;
							}
						);
					},
					err => {
						this.loading = false;
					}
				);
			}
			else{
				return;
			}
		});
	}

	onShowVenta(id){
		const initialState = {venta_id: id};
		this.bsModalRef = this.modalService.show(VentaModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));
	}
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/ventas/retenciones-list/retenciones-list.component.ts